import { v4 as uuidv4 } from "uuid";

class PlatformTool {
  private deviceId: string;

  constructor() {
    this.deviceId = this.loadOrGenerateDeviceId();
  }

  public async getDeviceIp(): Promise<string> {
    try {
      const response = await fetch("https://api64.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Error getting IP:", error);
      return "Unknown";
    }
  }

  public getPlatform(): string {
    try {
      return navigator.userAgent;
    } catch (error) {
      console.error("Error getting Platform:", error);
      return "Unknown";
    }
  }

  public getAppVersion(): string {
    try {
      return "1.0.0";
    } catch (error) {
      console.error("Error getting version:", error);
      return "Unknown";
    }
  }

  private loadOrGenerateDeviceId(): string {
    try {
      let deviceId = localStorage.getItem("deviceId");
      if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem("deviceId", deviceId!);
      }
      return deviceId!;
    } catch (error) {
      console.error("Error getting deviceId:", error);
      return "Unknown";
    }
  }

  public getDeviceId(): string {
    return this.deviceId;
  }

  public getDeviceInfoJson(): string {
    try {
      return JSON.stringify({
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        hardwareConcurrency: navigator.hardwareConcurrency,
        languages: navigator.languages,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
      });
    } catch (error) {
      console.error("Error getting deviceInfo:", error);
      return "{}";
    }
  }

  public getClientTimeData(): {
    clientTime: string;
    clientTimeZoneName: string;
    clientTimeZoneOffset: string;
  } {
    try {
      const now = new Date();
      return {
        clientTime: now.toISOString(),
        clientTimeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
        clientTimeZoneOffset: (now.getTimezoneOffset() / 60).toString(),
      };
    } catch (error) {
      console.error("Error getting time:", error);
      return {
        clientTime: "Unknown",
        clientTimeZoneName: "Unknown",
        clientTimeZoneOffset: "Unknown",
      };
    }
  }

  public async getDeviceData(): Promise<Record<string, string>> {
    try {
      const deviceIp = await this.getDeviceIp();
      return {
        deviceIp,
        platform: this.getPlatform(),
        appVersion: this.getAppVersion(),
        deviceId: this.getDeviceId(),
        deviceInfoJson: this.getDeviceInfoJson(),
        ...this.getClientTimeData(),
      };
    } catch (error) {
      console.error("Error getting deviceData:", error);
      return {};
    }
  }
}

export const platformTool = new PlatformTool();
